import { faDownload, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { useDownloadDocument } from '@uturn/api/v1';
import { queryDownloadFile } from '@uturn/portal/utils';
import {
	Badge,
	Button,
	badgeVariants,
	Card,
	CardContent,
	Icon,
	type VariantProps,
} from '@uturn/ui-kit';
import { useEffect } from 'react';

type BadgeVariant = VariantProps<typeof badgeVariants>['variant'];

type ShipmentDocumentTileProps = {
	title: string;
	subtitle: string;
	filename?: string;
	badge?: {
		label: string;
		variant?: BadgeVariant;
	};
	canDownload?: boolean;
	onDelete: () => void;
	uuid?: string;
};

export const ShipmentDocumentTile = ({
	title,
	subtitle,
	filename,
	badge,
	canDownload,
	onDelete,
	uuid,
}: ShipmentDocumentTileProps) => {
	const {
		data: downloadResponse,
		refetch: downloadDocument,
		isSuccess: isDownloadSuccess,
	} = useDownloadDocument(uuid ?? '', {
		query: { enabled: false },
		request: { responseType: 'blob' },
	});

	useEffect(() => {
		if (isDownloadSuccess) {
			queryDownloadFile(downloadResponse, `${title}-${subtitle}`);
		}
	}, [document, downloadResponse, isDownloadSuccess, downloadDocument]);
	return (
		<Card className="relative">
			<CardContent className=" flex items-center justify-between py-4">
				{badge ? (
					<Badge
						className="absolute top-1 right-1"
						variant={badge.variant ?? 'secondary'}
					>
						{badge.label}
					</Badge>
				) : null}
				<div className="flex items-start gap-3">
					<span className="text-secondary-700 flex flex-col text-sm">
						<span className="font-bold">{title}</span>
						{subtitle ? <span className="mb-0.5">{subtitle}</span> : null}
						{filename ? (
							<span className="text-xs opacity-80">{filename}</span>
						) : null}
					</span>
				</div>
				<div className="flex">
					{canDownload && uuid && (
						<Button
							variant="ghost"
							onClick={(e) => {
								e.preventDefault();
								downloadDocument();
							}}
						>
							<Icon icon={faDownload} className="size-4" />
						</Button>
					)}

					<Button
						variant="ghost"
						onClick={(e) => {
							e.preventDefault();
							onDelete();
						}}
					>
						<Icon icon={faTrashCan} className="size-4" />
					</Button>
				</div>
			</CardContent>
		</Card>
	);
};
